import { render } from "./Details.vue?vue&type=template&id=66330a36"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Partials/Details.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66330a36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66330a36', __exports__)) {
    console.log('reload')
    api.reload('66330a36', __exports__)
  }
  
  module.hot.accept("./Details.vue?vue&type=template&id=66330a36", () => {
    console.log('re-render')
    api.rerender('66330a36', render)
  })

}


export default __exports__